<template>
  <div class="modal fade" id="upload-media" tabindex="-1" aria-labelledby="uploadMediaLabel" aria-hidden="true" style="z-index: 1065;">
    <loading-modal :is-loading="isLoading"/>
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 480px;">
      <div class="modal-content text-left position-relative" style="background: #111114; border: 1px solid rgba(255,255,255,0.12); border-radius: 24px; box-shadow: 0 24px 60px rgba(0,0,0,0.85); overflow: hidden;">
        
        <!-- Top-Right Close Button -->
        <button type="button" class="close position-absolute" data-dismiss="modal" aria-label="Close"
                style="top: 16px; right: 20px; z-index: 10; opacity: 1; text-shadow: none; background: rgba(255,255,255,0.1); width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; border: none; cursor: pointer; transition: all 0.2s;">
          <i class="fa fa-times text-white font-size-14"></i>
        </button>

        <div class="modal-body p-4 p-md-5">
          <!-- Header Badge & Title -->
          <div class="mb-4 text-center">
            <div class="d-inline-flex align-items-center justify-content-center mb-3" style="width: 56px; height: 56px; border-radius: 50%; background: linear-gradient(135deg, rgba(243,218,107,0.2) 0%, rgba(229,59,185,0.2) 100%); border: 1px solid rgba(243,218,107,0.35);">
              <i class="fa fa-cloud-upload font-size-22" style="background: linear-gradient(90deg, #F3DA6B, #E53BB9); -webkit-background-clip: text; -webkit-text-fill-color: transparent;"></i>
            </div>
            <h4 class="text-white font-weight-700 mb-1 font-size-20" id="uploadMediaLabel">Upload Media</h4>
            <p class="text-muted font-size-13 mb-0">Share exclusive photos, videos, or animations</p>
          </div>

          <!-- Section 1: Media Dropzone / Preview -->
          <div class="form-group mb-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <label class="text-muted font-size-12 text-uppercase font-weight-bold mb-0" style="letter-spacing: 0.8px;">
                Media <span class="danger">*</span>
              </label>
              <button v-if="isFileSelected" type="button" class="btn btn-link text-muted font-size-12 p-0 text-decoration-none" @click="removeMedia">
                <i class="fa fa-trash-o text-danger me-1"></i> Remove
              </button>
            </div>

            <!-- Empty Dropzone State (Centered) -->
            <div v-show="!isFileSelected"
                 class="upload-dropzone p-4 text-center d-flex flex-column align-items-center justify-content-center cursor-pointer"
                 onclick="document.getElementById('fileInput').click();">
              <div class="upload-icon-circle mb-2 d-flex align-items-center justify-content-center">
                <i class="fa fa-cloud-upload font-size-20" style="color: #E53BB9;"></i>
              </div>
              <div class="text-white font-weight-600 font-size-14 mb-1">
                Browse for Media
              </div>
              <div class="text-muted font-size-12">
                Images, animations, or videos up to 500MB
              </div>
              <div class="text-muted font-size-11 mt-1" style="opacity: 0.75;">
                Supported formats: JPG, PNG, GIF, WebP, MP4, MOV
              </div>
            </div>

            <!-- Selected Media Preview State -->
            <div v-show="isFileSelected" class="upload-preview-card p-3 text-center position-relative">
              <button type="button" class="btn-change-media position-absolute"
                      onclick="document.getElementById('fileInput').click();" title="Change media">
                <i class="fa fa-refresh me-1"></i> Change
              </button>
              <div class="d-flex align-items-center justify-content-center" style="min-height: 120px;">
                <img v-show="!isVideo && isFileSelected" id="user_upload_image" src="@/assets/images/stella/no_avatar.png" alt="preview"
                     class="img-fluid rounded" style="max-height: 180px; object-fit: contain;">
                <video v-show="isVideo && isFileSelected" controls oncontextmenu="return false;" controlsList="nodownload"
                       id="user_upload_video" class="rounded w-100" style="max-height: 200px; background: #000;">
                </video>
              </div>
              <div v-if="selectedFileName" class="text-muted font-size-12 mt-2 text-truncate px-3">
                <i class="fa fa-file-image-o me-1" v-if="!isVideo"></i>
                <i class="fa fa-file-video-o me-1" v-else></i>
                {{ selectedFileName }}
              </div>
            </div>

            <!-- Hidden File Input -->
            <input type="file" class="d-none" id="fileInput" :accept="allowedMediaAccept" ref="file"
                   @change="loadFile($event)">

            <!-- Validation Error Messages -->
            <div class="danger ml-2 font-size-12 mt-2" v-if="fileErrorMessage">
              <i class="fa fa-exclamation-triangle me-1"></i> {{ fileErrorMessage }}
            </div>
            <div class="danger ml-2 font-size-12 mt-2" v-else-if="isSubmitted && !isFileSelected">
              <i class="fa fa-exclamation-circle me-1"></i> Please select a file
            </div>
          </div>

          <!-- Section 2: Message Field -->
          <div class="form-group mb-3">
            <label class="text-muted font-size-12 text-uppercase font-weight-bold mb-2 d-block" style="letter-spacing: 0.8px;">
              Message <span class="danger">*</span>
            </label>
            <div class="position-relative">
              <i class="fa fa-commenting-o position-absolute text-muted" style="left: 14px; top: 15px; font-size: 15px;"></i>
              <input type="text" class="cp-input form-control" style="padding-left: 40px !important;"
                     v-model="contentChatMessage.message"
                     placeholder="Enter message for subscribers...">
            </div>
            <div class="danger ml-2 font-size-12 mt-1" v-if="isSubmitted && !$v.contentChatMessage.message.required">
              Message is required
            </div>
          </div>

          <!-- Section 3: Price Field -->
          <div class="form-group mb-4">
            <label class="text-muted font-size-12 text-uppercase font-weight-bold mb-2 d-block" style="letter-spacing: 0.8px;">
              Price to unlock media <span class="danger">*</span>
            </label>
            <div class="position-relative">
              <span class="position-absolute text-muted font-weight-bold" style="left: 14px; top: 13px; font-size: 15px;">$</span>
              <input type="number" min="0" class="cp-input form-control" style="padding-left: 32px !important;"
                     v-model="contentChatMessage.content.price"
                     placeholder="25"
                     onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
            </div>
            <div class="danger ml-2 font-size-12 mt-1" v-if="isSubmitted && !$v.contentChatMessage.content.price.required">
              Price is required
            </div>
          </div>

          <!-- Dual Action Buttons (Side by Side) -->
          <div class="mt-4 pt-2 d-flex align-items-center justify-content-between" style="gap: 12px;">
            <button type="button" class="btn cp-btn-ghost flex-fill m-0 py-2" data-dismiss="modal">
              Cancel
            </button>
            <button type="button" class="btn cp-btn-primary button-class flex-fill m-0 py-2" @click="sendMsg()" :disabled="isLoading">
              <i v-if="isLoading" class="fa fa-spinner fa-spin me-1"></i>
              <i v-else class="fa fa-cloud-upload me-1"></i>
              Upload
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {httpMixin} from "@/mixin/http-mixin";
import {mapGetters} from "vuex";
import {SERVICE_DIRECT_MESSAGE} from "@/properties/micro-service";
import LoadingModal from "@/components/module/shared/LoadingModal";
import {required} from "vuelidate/lib/validators";
import RequiredField from "@/components/module/shared/RequiredField";
import {
  ALLOWED_MEDIA_ACCEPT,
  isMediaFile,
  isVideoFile,
  MEDIA_RESTRICTION_ERROR_MESSAGE
} from "@/common/media-utils";
import '@/assets/styles/direct-message/direct-message-common.css';

export default {
  name: 'UploadMedia',
  props: {
    messageType: {
      default: 'message'
    }
  },
  mixins: [httpMixin],
  components: {RequiredField, LoadingModal},
  data() {
    return {
      contentChatMessage: {content: {}},
      messageSetting: null,
      receiverId: null,
      filterId: null,
      isFileSelected: false,
      isSubmitted: false,
      isVideo: false,
      selectedFileName: null,
      fileErrorMessage: null,
      allowedMediaAccept: ALLOWED_MEDIA_ACCEPT,
    }
  },
  validations: {
    contentChatMessage: {
      message: {required},
      content: {price: {required}},
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    isMessage() {
      return this.messageType === 'message';
    },
  },
  methods: {
    show(receiverId, filterId) {
      $('#upload-media').modal();
      if (typeof $ !== 'undefined') {
        $("#user_upload_image").attr("src", require('@/assets/images/stella/no_avatar.png'));
        $("#user_upload_video").attr("src", "");
      }
      this.contentChatMessage = {content: {}};
      this.receiverId = receiverId;
      this.filterId = filterId;
      if (this.$refs.file) {
        this.$refs.file.value = null;
      }
      this.isFileSelected = false;
      this.isSubmitted = false;
      this.isVideo = false;
      this.selectedFileName = null;
      this.fileErrorMessage = null;
      this.getMessageSetting();
    },
    loadFile(event) {
      const file = this.$refs.file && this.$refs.file.files ? this.$refs.file.files[0] : null;
      if (!file) {
        this.isFileSelected = false;
        this.fileErrorMessage = null;
        this.selectedFileName = null;
        if (typeof $ !== 'undefined') {
          $('#user_upload_image').prop('src', require('@/assets/images/stella/no_avatar.png'));
          $("#user_upload_video").attr("src", "");
        }
        this.isVideo = false;
        return;
      }

      if (!isMediaFile(file)) {
        this.isFileSelected = false;
        this.fileErrorMessage = MEDIA_RESTRICTION_ERROR_MESSAGE;
        this.selectedFileName = null;
        this.$refs.file.value = "";
        if (typeof $ !== 'undefined') {
          $('#user_upload_image').prop('src', require('@/assets/images/stella/no_avatar.png'));
          $("#user_upload_video").attr("src", "");
        }
        this.isVideo = false;
        return;
      }

      this.fileErrorMessage = null;
      this.isFileSelected = true;
      this.selectedFileName = file.name;
      if (isVideoFile(file)) {
        this.isVideo = true;
        if (typeof $ !== 'undefined') {
          $('#user_upload_image').prop('src', "");
          $("#user_upload_video").attr("src", URL.createObjectURL(file));
        }
      } else {
        this.isVideo = false;
        if (typeof $ !== 'undefined') {
          $("#user_upload_video").attr("src", "");
          $('#user_upload_image').prop('src', URL.createObjectURL(file));
        }
      }
    },
    removeMedia() {
      if (this.$refs.file) {
        this.$refs.file.value = "";
      }
      this.isFileSelected = false;
      this.selectedFileName = null;
      this.fileErrorMessage = null;
      this.isVideo = false;
      if (typeof $ !== 'undefined') {
        $('#user_upload_image').prop('src', require('@/assets/images/stella/no_avatar.png'));
        $("#user_upload_video").attr("src", "");
      }
    },
    hide() {
      $('#upload-media').modal('hide');
    },
    getMessageSetting() {
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/message-settings/influencers/${this.getUser.id}`;
      this.getData(url, (messageSetting) => {
        this.messageSetting = messageSetting;
        if (messageSetting) {
          this.contentChatMessage.content = {price: messageSetting.pricePerFile};
        }
      })
    },
    sendMsg() {
      this.isSubmitted = true;
      this.$v.$touch();
      if (this.$v.$invalid || !this.isFileSelected || this.fileErrorMessage || !this.contentChatMessage.message) {
        return;
      }
      if (this.isMessage) {
        this.sendMessage();
      } else {
        this.filterMessage();
      }
    },
    filterMessage() {
      if (this.$v.$invalid || !this.$refs.file.files[0]) {
        return;
      }

      let infId = this.getUser.id;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/filter-messages/influencers/${infId}/filter/${this.filterId}/content`

      let contentChatStr = JSON.stringify(this.contentChatMessage);
      let formData = new FormData();
      formData.append('file', this.$refs.file.files[0]);
      formData.append('contentFilterMessage', contentChatStr);
      this.uploadData(url, formData, (message) => {
        this.hide();
        this.$emit('messageSent', message);
      });
    },

    sendMessage() {
      if (this.$v.$invalid || !this.$refs.file.files[0]) {
        return;
      }
      this.contentChatMessage.receiverId = this.receiverId;
      this.contentChatMessage.senderId = this.getUser.id;
      this.contentChatMessage.status = 'S';
      let contentChatStr = JSON.stringify(this.contentChatMessage);

      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/content`;
      let formData = new FormData();
      formData.append('file', this.$refs.file.files[0]);
      formData.append('contentChatMessage', contentChatStr);
      this.uploadData(url, formData, (message) => {
        this.hide();
        this.$emit('messageSent', message);
      });
    },
  }
}
</script>

<style scoped>
.upload-dropzone {
  border: 1.5px dashed rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.03);
  min-height: 140px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.upload-dropzone:hover {
  border-color: #E53BB9;
  background: rgba(229, 59, 185, 0.05);
  box-shadow: 0 0 16px rgba(229, 59, 185, 0.18);
}

.upload-icon-circle {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(229, 59, 185, 0.12);
  border: 1px solid rgba(229, 59, 185, 0.25);
}

.upload-preview-card {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.02);
}

.btn-change-media {
  top: 10px;
  right: 12px;
  z-index: 5;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-change-media:hover {
  background: rgba(229, 59, 185, 0.2);
  border-color: #E53BB9;
  color: #fff;
}

.cp-input {
  background: rgba(255, 255, 255, 0.06) !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-radius: 12px !important;
  color: #ffffff !important;
  height: 46px !important;
  font-size: 14px !important;
  transition: all 0.2s ease !important;
}

.cp-input:focus {
  border-color: #E53BB9 !important;
  box-shadow: 0 0 14px rgba(229, 59, 185, 0.35) !important;
  background: rgba(255, 255, 255, 0.08) !important;
}

.cp-input::placeholder {
  color: rgba(255, 255, 255, 0.38) !important;
}

.cp-input[type="number"]::-webkit-inner-spin-button,
.cp-input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.cp-input[type="number"] {
  -moz-appearance: textfield;
}

.danger {
  color: #FF4B81;
}
</style>
